// Module
var code = "<div class=\"content-center noDataTemplate\"> <i class=\"striimline-icon no-data\"></i> <label>{{text}}</label> </div> ";
// Exports
export default code;